import Vue from 'vue'
import slug from 'slug'

Vue.prototype.$slug = slug
